// extracted by mini-css-extract-plugin
export var dayLabel = "_j1-0";
export var pickerDisabled = "_j1-1";